import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Promotion } from '../../../../types/basket';
import { LOADING_TYPES } from '../../../../utils/checkoutState';
import { getAssetUrl } from '../../../../utils/config';
import LoadingIndicator from '../../../atoms/LoadingIndicator';
import './style.scss';

type PromotionListProps = {
  promotions: Promotion[];
  isLoading: string;
  removeHandler: (identifier: string) => Promise<void>;
};

const PromotionList = ({ promotions, isLoading, removeHandler }: PromotionListProps) => (
  <div className="promotions">
    {promotions.map(({ id, code, name }) => (
      <div className="promotions__item" key={id}>
        <div className="content">
          <img src={getAssetUrl('discount/discountActive.svg')} />
          {name ?? <FormattedMessage id="payment.promotion.fallbackCodeName" />}
          <div className="remove-promotion">
            <LoadingIndicator
              isSmall
              contentClassName={classNames('remove-promotion__loading', {
                'remove-promotion__loading--visible': isLoading === LOADING_TYPES.promotionRemove(code)
              })}
            />
            <img
              className={classNames('remove-promotion__remove-icon', {
                'remove-promotion__remove-icon--loading': isLoading === LOADING_TYPES.promotionRemove(code)
              })}
              src={getAssetUrl('common/removeActive.svg')}
              onClick={code ? () => removeHandler(code) : undefined}
            />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default PromotionList;
